//@flow
import React from 'react';

import {makeStyles, Typography} from '@material-ui/core';

import {formatPhoneNumber} from '../../../../../../utils/phone';
import {colors} from '../../../../../../assets/styles/colors';
import {isValidDisplayIdentifierOrPhone} from '../../../../chat/utils/conversation';

import type {CRMCustomer, ContactInformation} from '../../../../../../entities';

const useStyles = makeStyles(theme => ({
  subtitle: {
    color: colors.grey900,
    fontSize: 14,
    fontWeight: 500,
  },
  sidebarItem: {
    padding: '0 .5rem',
    '&:hover': {
      background: 'none',
    },
  },
  greyText: {
    color: colors.grey700,
    fontSize: 14,
    fontWeight: 400,
  },
  section: {
    padding: theme.spacing(0, 1),
  },
  row: {
    margin: theme.spacing(1, 0),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  contactInfoWrap: {
    marginTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  contactInfoRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
}));

type Props = {
  crmCustomer?: CRMCustomer,
  contactInformation: ContactInformation,
};

export default function ContactInformationSection(props: Props) {
  const {crmCustomer, contactInformation} = props;
  const classes = useStyles();

  const phone = contactInformation.phone ?? '';
  const customerPhone = !phone
    ? ''
    : isValidDisplayIdentifierOrPhone(phone)
    ? formatPhoneNumber(phone)
    : 'Usuario desconocido';

  return (
    <div className={classes.section}>
      <div className={classes.contactInfoWrap}>
        <div className={classes.contactInfoRow}>
          <Typography className={classes.greyText}>
            Número de teléfono
          </Typography>
          <Typography>{customerPhone}</Typography>
        </div>
        {crmCustomer && (
          <div className={classes.contactInfoRow}>
            <Typography className={classes.greyText}>Email</Typography>
            <Typography>{crmCustomer.email}</Typography>
          </div>
        )}
      </div>
    </div>
  );
}
